module.exports = __webpack_public_path__ + "images/emoji/octocat.2311adff960a3315f3bc.png";